export const getActions = (factura) => {
    const actions = {
        actions: [
            {
                label: 'Descargar PDF',
                icon: 'pdf',
                action: 'download'
            },
            {
                label: 'Regenerar',
                icon: 'regenerate',
                action: 'regenerate'
            }
        ],
        extra: []
    };

    if(!factura.devoluciones.find(f => f.tipo_factura_id === 3) && factura.tipo_factura_id === 1) {
        actions.actions.push({
            label: 'Generar Devolución',
            icon: 'refund',
            action: 'refund'
        })
    }


    return actions
}